var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "label-create-form-data" }, [
        _vm._v("VIEW CODE")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "btn-copy", on: { click: _vm.copyCode } }, [
        _c("i", {
          staticClass: "fa fa-files-o font-weight-bold cursor-pointer"
        }),
        _vm._v(" Copy\n  ")
      ]),
      _c("br"),
      _vm._v(" "),
      _vm.showEditor
        ? _c("j-monaco-editor", {
            ref: "scriptEditor",
            staticClass: "m__t--10",
            attrs: { value: _vm.jsonData, disable: true, language: "json" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { md: "6" } }, [
            _c("div", { staticStyle: { opacity: "0" } }, [
              _c("textarea", {
                ref: "viewCode",
                attrs: { id: "view-code" },
                domProps: { value: _vm.viewCode }
              })
            ])
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { md: "6" } }, [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeCodeForm }
                  },
                  [_vm._v("\n          Close\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-399ef3e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399ef3e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/popup/ModalViewCode.vue
// module id = null
// module chunks = 